import { Dayjs } from 'dayjs'

import { dayOfWeek } from '~/astra'

export const commentStyles = 'bg-emerald-300/10  small-triangle-bookmark'
export const blockedDataGridStyles = 'opacity-50 transition-opacity [&>*]:pointer-events-none'
export const closedCellStyles = 'bg-dashed-surface-strong hover:bg-dashed-surface-strong'
export const draggedChipClassName = 'pointer-events-none opacity-30 shadow-sm'

export function getWeekDividerStyles(date: Dayjs) {
    // divide the border between monday and friday cells
    // the border takes space away from the cells, so dividing it is more subtle
    const fridayStyles = 'border-r-[3px] border-r-neutral'
    // dont add the style to the first monday cell in the first week
    const mondayStyles = '[&:nth-child(2)]:border-l-0 border-l-[3px] border-l-neutral'
    const weekDay = dayOfWeek(date)
    if (weekDay === 1) return mondayStyles
    if (weekDay === 5) return fridayStyles
    return ''
}
